// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const Heading3IconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="Heading3Icon" ref={forwardedRef} {...props}>
      <path d="M1.75 4.5h1.556v11.249H1.75zm.809 4.841h6.337v1.446H2.559zM8.199 4.5h1.556v11.249H8.198z" />
      <path d="M12.918 15.669a6.5 6.5 0 0 1-1.597-.904L12.1 13.62a5 5 0 0 0 1.263.733 3.5 3.5 0 0 0 1.294.25c.475 0 .9-.09 1.273-.28a2.3 2.3 0 0 0 .9-.774 1.93 1.93 0 0 0 .333-1.104 1.8 1.8 0 0 0-.657-1.427c-.434-.371-1.01-.562-1.718-.572a4 4 0 0 0-.596.02 7 7 0 0 0-.597.12l-.758-1.124 4.7-4.62.212 1.144h-5.953V4.5h6.55l.02 1.466-3.85 3.777-.678-.08a3.6 3.6 0 0 1 .778-.272 4 4 0 0 1 .89-.1c.626 0 1.182.14 1.677.432a3.1 3.1 0 0 1 1.153 1.165 3.2 3.2 0 0 1 .414 1.627 3.3 3.3 0 0 1-.505 1.798c-.334.522-.819.934-1.425 1.235S15.526 16 14.778 16a4.8 4.8 0 0 1-1.84-.341z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const Heading3Icon = /* @__PURE__ */ Object.assign(
  Heading3IconComponent,
  { displayName: 'Heading3Icon' },
);
